import { makeStyles } from 'tss-react/mui'

export const useNavbarButtonClasses = makeStyles()(() => ({
  buttonCallToAction: {
    flex: '0 0 auto',
    minHeight: 0,
    fontWeight: 'bold',
  },
}))
